// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import TokenRequestViewModel from '../../../../viewModel/resource/TokenRequestViewModel';
import TokenRequestDTO from '../../dto/resource/TokenRequestDTO';

export default abstract class TokenRequestModel extends BaseModel<TokenRequestDTO> {
  /**
  */
  get userName() { return this.dto.userName; }
  set userName(value) { this.dto.userName = value; }
  /**
  */
  get password() { return this.dto.password; }
  set password(value) { this.dto.password = value; }
  /**
  */
  get shareId() { return this.dto.shareId; }
  set shareId(value) { this.dto.shareId = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.userName = qs.username;
    this.dto.password = qs.password;
    this.dto.shareId = qs.shareid;
  }
}
